module.exports = __webpack_public_path__ + "static/image_7_thumb-163b5d535813515c6a8a5e9a5d0d8e40.jpg";